<template>
    <div class="app-wrapper">
        <router-view/>
    </div>
</template>

<script>
export default {
    name: 'app',
    created(){
        console.log('App init');
    }
}
</script>

<style lang="scss">
    .app-wrapper{
        background:#fff;
        color:#333333;
        margin:0;
        padding:10px;
        font-family:"Trebuchet MS", sans-serif;
    }
</style>
